import { render, staticRenderFns } from "./index.vue?vue&type=template&id=15968efe&scoped=true"
import script from "./index.vue?vue&type=script&lang=jsx"
export * from "./index.vue?vue&type=script&lang=jsx"
import style0 from "./index.vue?vue&type=style&index=0&id=15968efe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15968efe",
  null
  
)

export default component.exports